<template src="./task.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  import LicenceCategories from "@/assets/json_data/licence_categories.json";
  var moment = require("moment");
  import $ from "jquery";
  export default {
    components: {},
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      datetime: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        var reqTString = "";
        for (let i = 11; i < 16; i++) {
          reqTString += data[i];
        }
        var arr = reqTString.split(":");
        if (arr[0] >= 12) {
          reqTString = arr[0] - 12 + ":" + arr[1] + " PM";
        } else {
          reqTString = arr[0] + ":" + arr[1] + " AM";
        }
        return reqdString + " " + reqTString;
      },
    },
    props: {
      RequestFor: String,
      RequestStatus: String,
      height: String / Number,
      DriverId: String / Number,
      VehicleId: String / Number,
      AssetId: String / Number,
    },
    data() {
      return {
        newHeight: "350px",
        UpcomingTask: [],
        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        Task: {},
        ShowTaskActionModel: "",
        TaskActionModelHeading: "",
        SubmitTask: {},
        TaskFilter: "All",
        PopupLoader: false,
        trailersModule: false,
        assetsModule: false,
        file: "",
        Categories: LicenceCategories,
        ViewDocument: {},
        ShowViewDetailModel: false,
        MOTType: "MOT",
        Branches: {},
        BranchFilter: "",
        branchModuleEnable: false,
        UpcomingTaskListLoader: false,
        urgent_task_excel_data: [],
        StorageType: "",
        license_front_image: "",
        license_back_image: "",
        ShowFileInput:false
      };
    },
    computed: {},
    mounted() {
      if (typeof this.height != "undefined") {
        this.newHeight = this.height + "px";
      }      
      this.GetCompanySubscription();
      this.GetCompanySubscriptionModule();
      this.GetBranches();
      this.GetUpcomingTaskList();
      this.initSubmitTaskObject();
    },
    methods: {
      checkNextPMI(){
        var obj = {
          token: localStorage.getItem("token"),
          date: this.SubmitTask.pmi_passed,
        };
        Axios.post(Endpoints.Vehicle.CalculateNextPmi, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.SubmitTask.next_pmi_due = Response.data.date;
          }
        });
      },
      showInput(event) {
        if (event.target.checked) {
          this.ShowFileInput = true;
        } else {
          this.ShowFileInput = false;
        }
      },
      exportActionNeeded() {
      	$("#export_upcoming_events").trigger("click");
      },	
      GetBranches() {
	    var obj = { token: localStorage.getItem("token"), select_branch: true };
	    Axios.post(Endpoints.Branch.List, obj).then((Response) => {
	        if (Response.data.success) {
	          this.Branches = Response.data.records;
	        }
	    });
      },
      GetCompanySubscriptionModule() {
		var FleetSubscription = JSON.parse(
			localStorage.getItem("FleetSubscription")
		);
		var fleet_modules = JSON.parse(FleetSubscription["fleet_modules"]);
		const isTrailer = fleet_modules["Trailers"];
		if (isTrailer) {
			this.trailersModule = true;
		}
		const isAssets = fleet_modules["Assets"];
		if (isAssets) {
			this.assetsModule = true;
		}
		const isBranches = fleet_modules["Branches"];
		var CompanyData = JSON.parse(localStorage.getItem("Company"));
		var NoOfBranches = CompanyData.no_of_branches;
		if (isBranches && NoOfBranches > 0) {
			this.branchModuleEnable = true;
		}           
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
      },
      initSubmitTaskObject() {
        var user = JSON.parse(localStorage.getItem("User"));
        this.SubmitTask = {
          action: 0,
          date_fixed: "",
          notes: "",
          confirm: false,
          licence_category: "",
          licence_number: "",
          licence_expiry_date: "",
          cpc_expiry_date: "",
          adr_expiry_date: "",
          mot_appointment_date: "",
          mot_appointment_time: "",
          mot_appointment_location: "",
          mot_passed: "",
          next_mot_date: "",
          next_pmi_due: "",
          pmi_appointment_date: "",
          pmi_appointment_time: "",
          pmi_appointment_location: "",
          pmi_passed: "",
          psv_appointment_date: "",
          psv_appointment_time: "",
          psv_appointment_location: "",
          psv_passed: "",
          service_booked_date: "",
          service_booked_time: "",
          service_booked_location: "",
          serviced_date: "",
          next_service_date: "",
          serviced_due_month: "1 Year",
          serviced_due_miles: "10000",
          serviced_due_soonest: "1",
          sorn: false,
          tax_auto_renew: false,
          tax_renew_date: "",
          action_username: user.forename + " " + user.surname,
          insurance_auto_renew: false,
          insurance_renew_date: "",
          service_document: "",
          service_document_name: "",
          penalty_point: "",
          last_service_hours: "",
          last_service_miles: "",
          current_hours:"",
          current_miles:"",
          next_service_hours:"",
          next_service_miles:""
        };
      },
      GetUpcomingTaskList() {        
      	this.UpcomingTaskListLoader=true;       	
        Axios.post(Endpoints.Task.GET_LIST, {
          token: localStorage.getItem("token"),
          RequestFor: this.RequestFor,
          VehicleId: this.VehicleId,
          DriverId: this.DriverId,
          AssetId: this.AssetId,
        }).then((Response) => {
        	if (Response.data.success) {
            	this.UpcomingTask = Response.data.upcoming_task;                
            	this.urgent_task_excel_data = [];
			    if (this.UpcomingTask.length > 0) {
			        this.UpcomingTask.forEach((element) => {    
                        if(this.RequestStatus && this.RequestStatus!=""){
                            if(!this.RequestStatus.includes(element.status)){                                
                                return;
                            }
                        }                   
                        var obj = {};
                        var status = "";
                        if (element.status == "red") {
                        status = "Expired";
                        } else if (element.status == "yellow") {
                        status = "Warning";
                        } else {
                        status = "Upcoming";
                        }
                        obj["Reg/Name"] = element.vrm;
                        obj["Branch"] = element.branch_name;
                        obj["Date"] = element.date;
                        obj["Event"] = element.event;
                        obj["Status"] = status;
                        this.urgent_task_excel_data.push(obj);
			        });	                    
			    }

			    var ActionsNeededCount = 0;
			    var redStatusCnt = 0;
				this.UpcomingTask.forEach((element, index) => {
					if (element.status == "red") {
					  ActionsNeededCount++;
					  redStatusCnt++;
					}
					if (element.status == "yellow") {
					  ActionsNeededCount++;
					}
				});

				if (document.getElementById("ActionsNeededCount")) {
					document.getElementById("ActionsNeededCount").innerHTML = ActionsNeededCount;
					if (redStatusCnt >= 1) {
					  document.getElementsByClassName("urgent-task-btn")[0].innerHTML = redStatusCnt + " Urgent Tasks Required";
					  document.getElementsByClassName("urgent-task-btn")[0].style.display = "block";
					} else {
					  document.getElementsByClassName("urgent-task-btn")[0].style.display = "none";
					}
				}
          	}
          	this.UpcomingTaskListLoader=false;
        }).catch(error=>{
		    this.UpcomingTaskListLoader=false;
		});
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      handleFrontFileUpload() {
      this.front_file = this.$refs.front_file.files[0];
        this.StorageType = "CFD";
      },
      handleBackFileUpload() {
        this.back_file = this.$refs.back_file.files[0];
        this.StorageType = "CFD";
      },
    UploadBackFile() {
      this.PopupLoader = false;
      //this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("storage_type", this.StorageType);
      formData.append("file", this.back_file);
      Axios.post(Endpoints.File.Upload, formData).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          this.license_back_image = Response.data.file;
          this.GenerateLicensePdf();
        } else {
          this.$swal("Error in File Uploading", "", "error").then(() => {});
        }
      });
    },
    GenerateLicensePdf() {
      this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("front_image", this.license_front_image);
      formData.append("back_image", this.license_back_image);
      Axios.post(Endpoints.Dcoument.GenerateLicensePdf, formData).then(
        (Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true) {
            this.SubmitTask.service_document = Response.data.file;
            this.SubmitTask.service_document_name = Response.data.file;
            $("#upload_img_btn").html("Upload Front / Back Image");
            this.TaskActionSubmit();
          } else {
            this.$swal("Error in File Uploading", "", "error").then(() => {});
          }
        }
      );
    },
      ShowTaskAction(task) {
      	this.initSubmitTaskObject()
        this.ShowTaskActionModel = true;
        this.TaskActionModelHeading = task.title
        console.log("task", task);
        //console.log("SubmitTask", this.SubmitTask);
        this.Task = task;
        this.TaskActionModelHeading = task.title
        /*if (task.type == "vehiclecheck" && task.status == "orange") {
          this.TaskActionModelHeading =
            this.RequestFor == "TrailerList" ||
            this.RequestFor == "TrailerProfile"
              ? "Trailer Check Warning Action"
              : "Vehicle Check Warning Action";
        }
        if (task.type == "vehiclecheck" && task.status == "red") {
          this.TaskActionModelHeading =
            this.RequestFor == "TrailerList" ||
            this.RequestFor == "TrailerProfile"
              ? "Trailer Check Failure Action"
              : "Vehicle Check Failure Action";
        }*/

        /*if (task.type == "document") {
          this.TaskActionModelHeading = "Document Expire";
        }

        if (task.type == "driver" && task.task_type == "license_expiry") {
          this.TaskActionModelHeading = "Licence Expire";
        }

        if (task.type == "driver" && task.task_type == "cpc_expiry") {
          this.TaskActionModelHeading = "CPC Expire";
        }

        if (task.type == "driver" && task.task_type == "adr_expiry") {
          this.TaskActionModelHeading = "ADR Expire";
        }

        if (task.type == "vehicle" && task.task_type == "mot_due") {
          this.TaskActionModelHeading = task.task;
        }

        if (task.type == "vehicle" && task.task_type == "psv_date") {
          this.TaskActionModelHeading = "PSV Expire";
        }

        if (task.type == "vehicle" && task.task_type == "next_pmi_due") {
          this.TaskActionModelHeading = "PMI Expire";
        }

        if (task.type == "vehicle" && task.task_type == "mot_appointment") {
          this.TaskActionModelHeading = task.task;
        }

        if (task.type == "vehicle" && task.type3) {
          this.MOTType = task.type3;
        }

        if ((task.type == "vehicle" || task.type == "trailer")  && task.task_type == "psv_appointment") {
          this.TaskActionModelHeading = "PSV Appointment";
        }

        if ((task.type == "vehicle" || task.type == "trailer")  && task.task_type == "pmi_appointment") {
          this.TaskActionModelHeading = "PMI Appointment";
        }

        if (task.type == "vehicle" && task.task_type == "service_due") {
          this.TaskActionModelHeading = "Service Due";
        }

        if (task.type == "vehicle" && task.task_type == "service_appointment") {
          this.TaskActionModelHeading = "Service Appointment";
        }

        if (task.type == "vehicle" && task.task_type == "tax_due") {
          this.TaskActionModelHeading = "Tax Due";
        }

        if (task.type == "vehicle" && task.task_type == "repair_appointment") {
          this.TaskActionModelHeading = task.task;
        }        

        if (task.type == "assets" && task.task_type == "service_due") {
          this.TaskActionModelHeading = "Assets Service Due";
      	} */

      	/*if (task.type == "assetscheck" && task.status == "orange") {
          this.TaskActionModelHeading = "Asset Check Warning Action";
        }
        if (task.type == "assetscheck" && task.status == "red") {
          this.TaskActionModelHeading = "Asset Check Failure Action";
        }*/
        
        /*if (task.type == "assets" && task.task_type == "repair_appointment") {
          this.TaskActionModelHeading = task.task;
        }

        if (task.type == "manual_task") {
          this.TaskActionModelHeading = "Manual Task";
        }*/
      },
      SaveTaskActionSubmit() {
        var error = false;
        var errorStr = "";

        /* check error for vehicle check*/
        if (this.Task.type == "vehiclecheck") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.date_fixed == "") {
            error = true;
            errorStr += "<li>Please Select Date Fixed</li>";
          }
          if (this.SubmitTask.action == 3 && !this.SubmitTask.confirm) {
            error = true;
            errorStr +=
              "<li>Please Confirm Clear warning without addressing</li>";
          }
          if (this.SubmitTask.action == 4 && this.SubmitTask.service_booked_date == "") {
            error = true;
            errorStr += "<li>Please Select Date of Repair Appointment </li>";
          }
        }

        /* check error for document*/
        if (this.Task.type == "document") {
          if (!this.SubmitTask.confirm) {
            error = true;
            errorStr +=
              "<li>Please Check Clear document from upcoming and expired tasks list</li>";
          }
        }

        /* check error for driver license_expiry*/
        if (this.Task.type == "driver" && this.Task.task_type == "license_expiry") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.licence_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter Licence Expiry Date</li>";
          }
        }

        /* check error for driver license_check*/
        if (this.Task.type == "driver" && this.Task.task_type == "license_check") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.penalty_point == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter Penalty Point</li>";
          }
        }         

        /* check error for driver CPC*/
        if (this.Task.type == "driver" && this.Task.task_type == "cpc_expiry") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.cpc_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter CPC Expiry Date</li>";
          }
        }

        /* check error for driver ADR*/
        if (this.Task.type == "driver" && this.Task.task_type == "adr_expiry") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.adr_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter ADR Expiry Date</li>";
          }
        }

        /* check error for MOT Due*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "mot_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.mot_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of MOT Appointment</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.mot_appointment_time == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Time of MOT Appointment</li>";
          }

	        if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.mot_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of MOT Appointment</li>";
	        }

          if (this.SubmitTask.action == 2 && this.SubmitTask.mot_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed MOT</li>";
          }
	      if (this.SubmitTask.action == 2 && this.SubmitTask.next_mot_date == "") {
            error = true;
            errorStr += "<li>Please Select Date of Next MOT Date</li>";
          }
        }

        /* check error for PMI Due*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "pmi_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.pmi_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PMI Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.pmi_appointment_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of PMI Appointment</li>";
	        }
	        if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.pmi_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of PMI Appointment</li>";
	        }
          if (this.SubmitTask.action == 2 && this.SubmitTask.pmi_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PMI</li>";
          }
        }

        /* check error for PSV Date*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "psv_date") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.psv_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PSV Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.psv_appointment_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of PSV Appointment</li>";
	        }
	        if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.psv_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of PSV Appointment</li>";
	        }
          if (this.SubmitTask.action == 2 && this.SubmitTask.psv_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PSV</li>";
          }
        }

        /* check error for MOT Appointment*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "mot_appointment") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.mot_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed MOT</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.next_mot_date == "") {
            error = true;
            errorStr += "<li>Please Select Next MOT Date</li>";
          }          
          /*if (this.SubmitTask.action == 2 && this.SubmitTask.next_pmi_due == "") {
            error = true;
            errorStr += "<li>Please Select Date of next PMI</li>";
          }*/
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.mot_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of MOT Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.mot_appointment_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of MOT Appointment</li>";
	        }

	        if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.mot_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of MOT Appointment</li>";
	        }
        }

        /* check error for PMI Appointment*/
        if ((this.Task.type == "vehicle" || this.Task.type == "trailer") && this.Task.task_type == "pmi_appointment") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.pmi_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PMI</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.pmi_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PMI Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.pmi_appointment_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of PMI Appointment</li>";
	        }

	        if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.pmi_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of PMI Appointment</li>";
	        }
        }

        /* check error for PSV Appointment*/
        if ((this.Task.type == "vehicle" || this.Task.type == "trailer") && this.Task.task_type == "psv_appointment") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.psv_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PSV</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.psv_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PSV Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.psv_appointment_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of PSV Appointment</li>";
	        }

	        if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.psv_appointment_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of PSV Appointment</li>";
	        }
        }

        /* check error for Service Due*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "service_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.service_booked_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of Service Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.service_booked_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of Service Appointment</li>";
	        }
	        if (
	          this.SubmitTask.action == 1 &&
	          this.SubmitTask.service_booked_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of Service Appointment</li>";
	        }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.serviced_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
          }
        }

        /* check error for Service Appointment*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "service_appointment") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.serviced_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
          }
          if (
            this.SubmitTask.action == 3 &&
            this.SubmitTask.service_booked_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of Service Appointment</li>";
          }
          if (
	          this.SubmitTask.action == 3 &&
	          this.SubmitTask.service_booked_time == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select Time of Service Appointment</li>";
	        }
	        if (
	          this.SubmitTask.action == 3 &&
	          this.SubmitTask.service_booked_location == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Enter Location of Service Appointment</li>";
	        }
        }

        /* check error for Tax Due*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "tax_due") {
          if (
            this.SubmitTask.sorn == false &&
            this.SubmitTask.tax_auto_renew == false &&
            this.SubmitTask.tax_renew_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Any Action</li>";
          }
        }

        /* check error for Tax Due*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "insurance_expire" ) {
          if (
            this.SubmitTask.insurance_auto_renew == false &&
            this.SubmitTask.insurance_renew_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Any Action</li>";
          }
        }

        /* check error for repair Appointment*/
        if (this.Task.type == "vehicle" && this.Task.task_type == "repair_appointment") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.date_fixed == "") {
            error = true;
            errorStr += "<li>Please Select Date of vehicle repaired</li>";
          } 
          if ( this.SubmitTask.action == 2 && this.SubmitTask.service_booked_date == "") {
            error = true;
            errorStr += "<li>Please Select Date of Repair Appointment</li>";
          }
          if (this.SubmitTask.action == 2 && this.SubmitTask.service_booked_time == "") {
	        error = true;
	        errorStr += "<li>Please Select Time of Repair Appointment</li>";
	      }
	      if (this.SubmitTask.action == 2 && this.SubmitTask.service_booked_location == "") {
	        error = true;
	        errorStr += "<li>Please Enter Location of Repair Appointment</li>";
	      }       
          
        }

        /* check error for Assets Service Due*/
      	if (this.Task.type == "assets" && this.Task.task_type == "service_due") {
	        if (this.SubmitTask.action < 1) {
	          error = true;
	          errorStr += "<li>Please Select Action</li>";
	        }
	        if (
	          this.SubmitTask.action == 2 &&
	          this.SubmitTask.serviced_date == ""
	        ) {
	          error = true;
	          errorStr += "<li>Please Select When was this Assets Serviced</li>";
	        }
      	}

      	/* check error for assets check*/
        if (this.Task.type == "assetscheck") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.date_fixed == "") {
            error = true;
            errorStr += "<li>Please Select Date Fixed</li>";
          }
          if (this.SubmitTask.action == 3 && !this.SubmitTask.confirm) {
            error = true;
            errorStr +=
              "<li>Please Confirm Clear warning without addressing</li>";
          }
          if (this.SubmitTask.action == 4 && this.SubmitTask.service_booked_date == "") {
            error = true;
            errorStr += "<li>Please Select Date of Repair Appointment </li>";
          }

        }

        /* check error for Manual Task*/
        if (this.Task.type == "manual_task") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.date_fixed == "") {
            error = true;
            errorStr += "<li>Please Select Date of Completion</li>";
          }
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          if(this.ShowFileInput){
            if (this.front_file != "" && this.back_file != "") {
              this.PopupLoader = true;
              $("#upload_img_btn").html("Processing...");
              let formData = new FormData();
              formData.append("token", localStorage.getItem("token"));
              formData.append("storage_type", this.StorageType);
              formData.append("file", this.front_file);
              Axios.post(Endpoints.File.Upload, formData).then((Response) => {
              this.PopupLoader = false;
              if (Response.data.success == true) {
                this.license_front_image = Response.data.file;
                this.UploadBackFile();
              } else {
                this.$swal
                    .fire("Error in File Uploading", "", "error")
                    .then(() => {});
              }
              });
            } else {
              this.TaskActionSubmit();
            }
          }else{
            if (this.$refs && this.$refs.file && this.$refs.file.files[0]) {
              this.PopupLoader = true;
              let formData = new FormData();
              formData.append("token", localStorage.getItem("token"));
              formData.append("storage_type", "CFV");
              formData.append("file", this.file);
              Axios.post(Endpoints.File.Upload, formData).then((Response) => {
                this.PopupLoader = false;
                if (Response.data.success == true) {
                  this.SubmitTask.service_document = Response.data.file;
                  this.SubmitTask.service_document_name = this.file.name;
                  this.TaskActionSubmit();
                } else {
                  this.$swal
                    .fire("Error in File Uploading", "", "error")
                    .then(() => {});
                }
              });
            }else{
              this.TaskActionSubmit();
            }
          }
        }
      },      
      TaskActionSubmit() {
        //console.log("task", this.Task);
        //console.log("SubmitTask", this.SubmitTask);
        this.PopupLoader = true;
          this.$swal({
            title: "Updating Task...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Task.TaskSubmit, {
            token: localStorage.getItem("token"),
            Task: this.Task,
            SubmitTask: this.SubmitTask,
          }).then((Response) => {
            if (Response.data.success == true) {
              this.ShowTaskActionModel = false;
              this.PopupLoader = false;
              this.GetUpcomingTaskList();
              this.initSubmitTaskObject();
              this.$swal("Task Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response.data.message, "", "error").then(() => {});
            }
          });
      },
      ViewDetailDocument(document) {        
        this.ViewDocument = document;
        this.ShowViewDetailModel = true;
      },  
      GetNextServiceHours(task){
      	if(+this.SubmitTask.last_service_hours > 0 && +task.service_interval_hours > 0){
      		this.SubmitTask.next_service_hours = +this.SubmitTask.last_service_hours + +task.service_interval_hours
      	}
      },
      GetNextServiceMiles(task){      	
      	if(+this.SubmitTask.last_service_miles > 0 && +task.service_interval_miles > 0){
      		this.SubmitTask.next_service_miles = +this.SubmitTask.last_service_miles + +task.service_interval_miles
      	}
      },
      GetNextServiceDate(task){      	
      	if(this.SubmitTask.serviced_date !="" && +task.service_interval_months > 0){
      		var newDate = moment(this.SubmitTask.serviced_date).add(+task.service_interval_months, 'M').format('YYYY-MM-DD');       		      		
      		this.SubmitTask.next_service_date = newDate
      	}
      },
      GetNextMotDate(){
      	var dt1 = moment(this.Task.date2)
      	var mot_due = this.Task.date2
      	if(this.Task.task_type=="mot_appointment"){
      		dt1 = moment(this.Task.mot_due)
      		mot_due = this.Task.mot_due
      	}
      	var dt2 = moment(this.SubmitTask.mot_passed)      	
      	if(dt1>=dt2){
      		var newDate = moment(mot_due).add(+1, 'Y').format('YYYY-MM-DD');      		
      		this.SubmitTask.next_mot_date = newDate
      	}
      	if(dt1<dt2){
      		var newDate = moment(this.SubmitTask.mot_passed).add(+1, 'Y').format('YYYY-MM-DD');      		
      		this.SubmitTask.next_mot_date = newDate
      	}       	

      },    
    },
  };
</script>

<style type="text/css">
  .UpcomingTaskList td {
    vertical-align: top !important;
    padding-top: 5px !important;
    font-weight: normal !important;
  }
  .UpcomingTaskList td.statusbtn .btn,
  .UpcomingTaskList td.actionbtn .btn {
    width: 100%;
  }
  .UpcomingTaskList td.statusbtn .btn.btn-blue {
    background: #32A2E1 !important;
    border-color: #32A2E1 !important;
    color: #FFF;
  }
  .UpcomingTaskList td.event,
  .UpcomingTaskList td.vrm {
    text-transform: capitalize;
  }
  .UpcomingTaskList .completebtn.btn-primary:hover {
    background-color: #51bb25 !important;
    border-color: #51bb25 !important;
  }
  #ShowTaskActionModel span.plate,
  #ShowTaskActionModel span.reg_plate {
    display: inline-flex;
    vertical-align: top;
  }
  #ShowTaskActionModel .form-control-check {
    margin-left: 10px;
    margin-right: 3px;
    vertical-align: text-top;
  }
</style>
